// extracted by mini-css-extract-plugin
export default {"arena":"ArenaView_arena__NDCb9","headernav":"ArenaView_headernav__fqXyn","container":"ArenaView_container__l3D1E","battleZone":"ArenaView_battleZone__gvO2q"};